/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import AOS from "aos";
import "./dist/aos.css"; // You can also use <link> for styles

/* eslint-disable no-console */
AOS.init();

// const customEasing = () => {
let head = document.head;
const styleEle = document.createElement("style");
styleEle.innerHTML = `
[data-aos][data-aos][data-aos-easing="easing-custom"],body[data-aos-easing="easing-custom"] [data-aos] {
transition-timing-function: cubic-bezier(0.77, -0.88, 0.09, 2.08)
}`;
head.appendChild(styleEle);
